import { useQuery } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";

export const useCheckSsoDomain = (email: string) =>
  useQuery({
    queryKey: ["check-sso-domain", email],
    queryFn: async () => {
      const res = await client.sso["check-domain"].$get({ query: { email } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: email.includes("@"),
    placeholderData: (previous) => previous,
  });
